/* Native Shopify forms. Only variant GET rendering is enhanced; cart owns POST. */
(() => {
  if (!customElements.get('tb-product')) customElements.define('tb-product', class extends HTMLElement {
    connectedCallback() {
      if (this.events) return;
      this.events = new AbortController();
      this.setAttribute('data-enhanced', 'true');
      this.prepareSelectors();
      if (this.querySelector('[data-tb-buy][data-needs-choice="true"]')) this.lock();
      this.addEventListener('change', e => {
        if (e.target.closest('tb-product') !== this) return;
        if (e.target.matches('[data-tb-variant-radio]')) {
          const select = e.target.closest('[data-tb-variant-form]').querySelector('[data-tb-variant]');
          select.value = e.target.value; this.update(select);
        } else if (e.target.matches('[data-tb-variant]')) this.update(e.target);
      }, {signal: this.events.signal});
      this.addEventListener('formdata', e => {
        if (e.target.matches('[data-tb-variant-form]')) e.formData.delete('tb-variant-choice');
      }, {signal: this.events.signal});
      this.addEventListener('submit', e => {
        if (!e.target.matches('.tb-native-product-form')) return;
        if (this.busy || this.hasAttribute('data-variant-error') || !e.target.querySelector('[name="id"]:not(:disabled)') || e.target.querySelector('[name="add"]')?.disabled !== false) { e.preventDefault(); return; }
        e.target.dispatchEvent(new CustomEvent('product-form:prepare', {bubbles: true, detail: {form: e.target}}));
      }, {signal: this.events.signal});
    }
    disconnectedCallback() { this.events?.abort(); this.request?.abort(); this.events = null; }
    prepareSelectors() {
      this.querySelectorAll('[data-tb-variant-form]').forEach(form => {
        const select = form.querySelector('[data-tb-variant]');
        const options = form.querySelector('[data-tb-variant-options]'); if (options) options.disabled = false;
        if (form.querySelector('[data-tb-variant-radio]')) { select.tabIndex = -1; select.setAttribute('aria-hidden', 'true'); }
        form.querySelectorAll('[data-tb-variant-radio]').forEach(r => r.checked = r.value === select.value);
      });
    }
    lock() {
      this.busy = true; this.setAttribute('aria-busy', 'true');
      this.querySelectorAll('[data-tb-buy] [name="add"], [data-tb-buy] [name="id"]').forEach(e => e.disabled = true);
      this.querySelectorAll('[data-tb-buy] .shopify-payment-button').forEach(e => { e.hidden = true; e.inert = true; });
    }
    async update(select) {
      this.request?.abort(); const request = this.request = new AbortController();
      const id = select.value;
      this.lock(); this.removeAttribute('data-variant-error'); this.prepareSelectors();
      const stock = this.querySelector('[data-tb-stock]');
      const errorBox = this.querySelector('.product-form-error'); if (errorBox) errorBox.textContent = '';
      if (!id) { if (stock) stock.textContent = 'Choisissez une variante.'; return; }
      if (stock) stock.textContent = 'Vérification de la disponibilité…';
      const quantity = this.querySelector('[data-tb-buy] [name="quantity"]')?.value;
      try {
        const url = new URL(this.dataset.url, location.origin);
        if (url.origin !== location.origin || !/^\d+$/.test(id) || ![...select.options].some(o => o.value === id)) throw Error('selection');
        url.searchParams.set('variant', id); url.searchParams.set('section_id', this.dataset.section);
        if (this.dataset.view) url.searchParams.set('view', this.dataset.view);
        const response = await fetch(url, {signal: request.signal, credentials: 'same-origin', headers: {'Accept': 'text/html'}});
        if (!response.ok) throw Error('section');
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        if (request !== this.request || request.signal.aborted || !this.isConnected) return;
        const source = [...doc.querySelectorAll('tb-product')].find(el => el.dataset.productId === this.dataset.productId && el.dataset.section === this.dataset.section);
        if (!source || source.dataset.variantId !== id) throw Error('variant');
        const selectors = ['[data-tb-buy]'];
        if (this.querySelector('[data-tb-price]')) selectors.unshift('[data-tb-price]');
        if (this.querySelector('[data-tb-price-save]')) selectors.unshift('[data-tb-price-save]');
        if (selectors.some(s => !source.querySelector(s) || !this.querySelector(s) || source.querySelector(s).dataset.variantId !== id)) throw Error('markup');
        const buy = source.querySelector('[data-tb-buy]');
        const form = buy.querySelector('.tb-native-product-form[data-type="add-to-cart-form"]');
        const variantInput = form?.querySelector('[name="id"]');
        const button = form?.querySelector('button[name="add"].tb-product-submit');
        const available = buy.dataset.available === 'true';
        if (!form || !variantInput || variantInput.value !== id || !button || buy.dataset.needsChoice === 'true' || !['true', 'false'].includes(buy.dataset.available) || variantInput.disabled !== !available || button.disabled !== !available) throw Error('purchase');
        // Validate all fragments before touching live DOM; inserted purchase stays locked until commit.
        variantInput.disabled = true; button.disabled = true;
        buy.querySelectorAll('.shopify-payment-button').forEach(e => { e.hidden = true; e.inert = true; });
        const freshSelect = source.querySelector('[data-tb-variant]');
        if (!freshSelect || freshSelect.value !== id) throw Error('selector');
        const freshOptions = source.querySelector('[data-tb-variant-options]');
        for (const s of selectors) this.querySelector(s).replaceWith(source.querySelector(s));
        select.innerHTML = freshSelect.innerHTML;
        const options = this.querySelector('[data-tb-variant-options]');
        // Preserve the focused radio node. Its caption can change with native price/stock.
        if (options && freshOptions) options.querySelectorAll('[data-tb-variant-radio]').forEach(r => {
          const fresh = [...freshOptions.querySelectorAll('[data-tb-variant-radio]')].find(f => f.value === r.value);
          if (fresh) r.nextElementSibling.replaceWith(fresh.nextElementSibling.cloneNode(true));
        });
        this.prepareSelectors();
        const input = this.querySelector('[data-tb-buy] [name="quantity"]');
        if (input && quantity) { input.value = quantity; if (!input.checkValidity()) input.value = input.min || '1'; }
        this.querySelector('tb-product-media')?.show(source.querySelector('tb-product-media')?.dataset.currentMedia);
        if (this.dataset.updateUrl !== 'false') { const next = new URL(location.href); next.searchParams.set('variant', id); history.replaceState({}, '', next); }
        this.dataset.variantId = id;
        variantInput.disabled = !available; button.disabled = !available;
        buy.querySelectorAll('.shopify-payment-button').forEach(e => { e.hidden = !available; e.inert = !available; });
        this.busy = false; this.removeAttribute('aria-busy');
      } catch (error) {
        if (request.signal.aborted || request !== this.request || !this.isConnected) return;
        this.lock(); // Re-lock the actual DOM, including any partially replaced form.
        const stock = this.querySelector('[data-tb-stock]'); if (stock) stock.textContent = 'Disponibilité non vérifiée.';
        const price = this.querySelector('[data-tb-price]'); if (price) price.textContent = 'Prix non vérifié';
        const save = this.querySelector('[data-tb-price-save]'); if (save) save.textContent = '';
        this.setAttribute('data-variant-error', 'true');
        const box = this.querySelector('.product-form-error'); if (box) box.textContent = 'Impossible de charger cette variante. Utilisez « Afficher cette variante » pour réessayer.';
        return;
      }
      this.dispatchEvent(new CustomEvent('product:variant-change', {bubbles: true, detail: {productId: this.dataset.productId, variantId: id, root: this}}));
      // Optional integration cannot turn a verified native purchase into a variant failure.
      const paymentFailed = () => { this.querySelectorAll('[data-tb-buy] .shopify-payment-button').forEach(e => { e.hidden = true; e.inert = true; }); };
      try { Promise.resolve(window.Shopify?.PaymentButton?.init()).catch(() => { if (request === this.request) paymentFailed(); }); } catch (error) { paymentFailed(); }
    }
  });
  if (!customElements.get('tb-product-media')) customElements.define('tb-product-media', class extends HTMLElement {
    connectedCallback() {
      if (this.events) return;
      this.events = new AbortController();
      const track = this.querySelector('[data-tb-track]');
      this.setupGallery();
      this.addEventListener('click', e => { const a = e.target.closest('[data-tb-media-target]'); if (a && this.contains(a)) { e.preventDefault(); this.show(a.dataset.tbMediaTarget); } }, {signal: this.events.signal});
      track?.addEventListener('keydown', e => {
        if (e.target !== track || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(e.key)) return;
        const items = [...this.querySelectorAll('[data-media-id]')];
        const index = items.findIndex(el => el.dataset.mediaId === this.dataset.currentMedia);
        const next = e.key === 'Home' ? 0 : e.key === 'End' ? items.length - 1 : Math.max(0, Math.min(items.length - 1, index + (e.key === 'ArrowRight' ? 1 : -1)));
        if (items[next]) { e.preventDefault(); this.show(items[next].dataset.mediaId); }
      }, {signal: this.events.signal});
      track?.addEventListener('scroll', () => {
        if (getComputedStyle(track).display === 'grid') return;
        cancelAnimationFrame(this.scrollFrame);
        this.scrollFrame = requestAnimationFrame(() => {
          const left = track.getBoundingClientRect().left;
          const item = [...track.children].reduce((best, el) => !best || Math.abs(el.getBoundingClientRect().left - left) < Math.abs(best.getBoundingClientRect().left - left) ? el : best, null);
          if (item) this.mark(item);
        });
      }, {signal: this.events.signal, passive: true});
      this.show(this.dataset.currentMedia);
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      cancelAnimationFrame(this.measureFrame); cancelAnimationFrame(this.scrollFrame);
      this.closeImage(); this.restoreImageFocus(); this.imageDialog?.remove(); this.imageDialog = null;
      this.events?.abort(); this.events = null;
      this.querySelectorAll('[data-media-id]').forEach(item => { item.inert = false; item.removeAttribute('aria-hidden'); });
    }
    setupGallery() {
      const signal = this.events.signal;
      this.viewport = this.querySelector('[data-media-viewport]');
      this.track = this.querySelector('[data-tb-track]');
      this.toggle = this.querySelector('[data-gallery-toggle]');
      this.info = this.closest('tb-product.tb-pdp-buy')?.querySelector('.product-info');
      this.expanded = false;
      const measure = () => { cancelAnimationFrame(this.measureFrame); this.measureFrame = requestAnimationFrame(() => this.measureGallery()); };
      this.toggle?.addEventListener('click', () => {
        const reducing = this.expanded;
        this.expanded = !this.expanded;
        this.measureGallery();
        if (reducing) this.toggle.scrollIntoView({block:'nearest', behavior:'instant'});
      }, {signal});
      if (window.ResizeObserver && this.info) {
        this.observer = new ResizeObserver(measure);
        this.observer.observe(this.info.firstElementChild || this.info);
        this.observer.observe(this.track);
      }
      window.addEventListener('resize', measure, {signal});
      this.addEventListener('load', measure, {capture:true, signal});
      this.closest('tb-product')?.addEventListener('product:variant-change', measure, {signal});
      measure();
      this.addEventListener('click', event => {
        const link = event.target.closest('[data-tb-image-open]');
        if (!link || !this.contains(link) || event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || !window.HTMLDialogElement?.prototype.showModal) return;
        event.preventDefault();
        this.openImage(link);
      }, {signal});
    }
    measureGallery() {
      if (!this.isConnected || !this.viewport || !this.toggle || !this.track) return;
      const desktop = matchMedia('(min-width:1024px)').matches;
      const applies = desktop && this.info && this.dataset.collapse !== 'false' && getComputedStyle(this.track).display === 'grid';
      const infoHeight = this.info ? (this.info.firstElementChild || this.info).getBoundingClientRect().height : 0;
      const available = applies ? this.info.getBoundingClientRect().top - this.getBoundingClientRect().top + infoHeight : 0;
      const overflow = applies && available > 240 && this.track.scrollHeight > available + 12;
      this.dataset.overflow = String(Boolean(overflow));
      this.dataset.expanded = String(this.expanded);
      this.toggle.parentElement.hidden = !overflow;
      this.toggle.setAttribute('aria-expanded', String(this.expanded));
      this.toggle.textContent = this.expanded ? 'Voir moins' : 'Voir plus';
      const nav = this.querySelector('.tb-media-nav');
      const navHeight = nav ? nav.getBoundingClientRect().height : 0;
      const toolbarHeight = overflow ? this.toggle.parentElement.getBoundingClientRect().height : 0;
      const limit = Math.max(160, Math.floor(available - toolbarHeight - navHeight));
      this.style.setProperty('--tb-gallery-clip', limit + 'px');
      const clipped = overflow && !this.expanded;
      const top = this.track.getBoundingClientRect().top;
      this.track.querySelectorAll('[data-media-id]').forEach(item => {
        const hidden = clipped && item.getBoundingClientRect().top - top >= limit - 60;
        item.inert = hidden;
        if (hidden) { item.setAttribute('aria-hidden', 'true'); item.querySelector('video')?.pause(); }
        else item.removeAttribute('aria-hidden');
      });
    }
    openImage(link) {
      if (!this.imageDialog) {
        const dialog = this.imageDialog = document.createElement('dialog');
        dialog.className = 'tb-image-dialog';
        dialog.setAttribute('aria-label', 'Image du produit en grand');
        dialog.innerHTML = '<div class="tb-image-dialog__bar"><p data-image-count role="status"></p><button type="button" data-image-close aria-label="Fermer l’image">Fermer</button></div><div class="tb-image-dialog__stage"><img alt=""><p data-image-error hidden>L’image n’a pas pu être chargée. <a target="_blank" rel="noopener">Ouvrir l’original</a></p></div><div class="tb-image-dialog__nav"><button type="button" data-image-prev aria-label="Image précédente">Précédente</button><button type="button" data-image-next aria-label="Image suivante">Suivante</button></div>';
        const signal = this.events.signal;
        dialog.querySelector('[data-image-close]').addEventListener('click', () => this.closeImage(), {signal});
        dialog.querySelector('[data-image-prev]').addEventListener('click', () => this.moveImage(-1), {signal});
        dialog.querySelector('[data-image-next]').addEventListener('click', () => this.moveImage(1), {signal});
        dialog.addEventListener('cancel', event => { event.preventDefault(); this.closeImage(); }, {signal});
        dialog.addEventListener('close', () => this.restoreImageFocus(), {signal});
        dialog.addEventListener('click', event => {
          if (event.target !== dialog) return;
          const r = dialog.getBoundingClientRect();
          if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) this.closeImage();
        }, {signal});
        dialog.addEventListener('keydown', event => {
          if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') { event.preventDefault(); event.stopPropagation(); this.moveImage(event.key === 'ArrowRight' ? 1 : -1); }
          if (event.key === 'Tab') {
            const focusable = [...dialog.querySelectorAll('button,a[href]')].filter(el => !el.disabled && !el.closest('[hidden]'));
            const first = focusable[0], last = focusable.at(-1);
            if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
            else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
          }
        }, {signal});
        const img = dialog.querySelector('img');
        img.addEventListener('error', () => { dialog.querySelector('[data-image-error]').hidden = false; }, {signal});
        img.addEventListener('load', () => { dialog.querySelector('[data-image-error]').hidden = true; }, {signal});
        document.body.append(dialog);
      }
      document.querySelectorAll('dialog.tb-image-dialog[open], dialog.tb-video-dialog[open]').forEach(d => d.close());
      this.imageOpener = link;
      this.imageLinks = [...this.querySelectorAll('[data-tb-image-open]')];
      this.imageIndex = this.imageLinks.indexOf(link);
      this.renderImage();
      this.imageDialog.showModal();
      document.body.classList.add('tb-image-modal-open');
      this.imageDialog.querySelector('[data-image-close]').focus();
    }
    moveImage(delta) {
      this.imageIndex = (this.imageIndex + delta + this.imageLinks.length) % this.imageLinks.length;
      this.renderImage();
    }
    renderImage() {
      const link = this.imageLinks[this.imageIndex];
      const original = link.closest('[data-media-id]').querySelector('img');
      const img = this.imageDialog.querySelector('img');
      img.alt = original?.alt || 'Image du produit';
      img.src = link.href;
      this.imageDialog.querySelector('[data-image-error]').hidden = true;
      this.imageDialog.querySelector('[data-image-error] a').href = link.href;
      this.imageDialog.querySelector('[data-image-count]').textContent = 'Image ' + (this.imageIndex + 1) + ' sur ' + this.imageLinks.length;
      this.imageDialog.querySelectorAll('[data-image-prev],[data-image-next]').forEach(b => { b.hidden = this.imageLinks.length < 2; });
    }
    closeImage() { this.imageDialog?.close(); }
    restoreImageFocus() {
      if (!document.querySelector('dialog.tb-image-dialog[open]')) document.body.classList.remove('tb-image-modal-open');
      if (this.imageOpener?.isConnected) this.imageOpener.focus({preventScroll:true});
    }

    mark(item) {
      this.dataset.currentMedia = item.dataset.mediaId;
      this.querySelectorAll('[data-tb-media-target]').forEach(a => { if (a.dataset.tbMediaTarget === item.dataset.mediaId) a.setAttribute('aria-current', 'true'); else a.removeAttribute('aria-current'); });
      this.querySelectorAll('video').forEach(v => { if (!item.contains(v)) v.pause(); });
    }
    show(id) {
      const item = [...this.querySelectorAll('[data-media-id]')].find(el => el.dataset.mediaId === String(id));
      const track = this.querySelector('[data-tb-track]'); if (!item || !track) return;
      if (getComputedStyle(track).display === 'grid') {
        if (this.dataset.currentMedia !== String(id)) {
          if (this.dataset.overflow === 'true' && !this.expanded && item.getBoundingClientRect().bottom > this.viewport.getBoundingClientRect().bottom) { this.expanded = true; this.measureGallery(); }
          item.scrollIntoView({block: 'nearest', behavior: 'instant'});
        }
      } else track.scrollTo({left: item.offsetLeft - track.offsetLeft, behavior: 'instant'});
      this.mark(item);
    }
  });
})();
